const utils = {
  dateFormat (value) {
    //Date对象转化为yyyy-MM-dd格式
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
  },
   fileNameRand : function() {
    //message_file_2020_7_8_
    var date = new Date();
    var year = date.getFullYear(); //获取完整的年份(4位)
    var month = date.getMonth() + 1 ; //获取当前月份(0-11,0代表1月)
    var datedate = date.getDate(); //获取当前日(1-31)
    return 'Message_File_'+year+'_'+month+'_'+datedate+'_'+utils.GenNonDuplicateID()+'_'

  },
   /**
   * 生成一个用不重复的ID
   */
  GenNonDuplicateID : function() {
      let str = Math.random().toString(36).substr(3);
      str += Date.now().toString(16).substr(4);
      return str;
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/utils/util.js